import { useSlice } from "./useSlice";

export function useCSRFToken() {
  return useSlice("config").csrfToken;
}
